module.exports = __webpack_public_path__ + "assets/img/mecha2-84a0d5f1.jpg";